import { gql } from '@apollo/client';


export const GET_NARRATIVE_TEMPLATES = gql`
  query GET_NARRATIVE_TEMPLATES($originatorId: ID!, $oriId: ID!){
    getNarrativeTemplates(originatorId: $originatorId, oriId: $oriId) {
      id
      name
      content
      position
      ori {
        id
        abbreviation
      }
      templateType
    }
  }
`;